<div class="page-wrapper flex flex-col" *transloco="let t">
  @if (gridData().length > 0) {
    <div class="flex w-full items-center justify-between">
      <div class="flex min-w-0 flex-1 items-center">
        <IFormField class="w-1/4">
          <input
            iInput
            [ngModel]="filter"
            (ngModelChange)="changeFilter($event)"
            size="sm"
            placeholder="{{ t('keyword-tracker-page.search_search_term') }}"
        /></IFormField>

        <IMultiSelectMenu
          [value]="selectedSegments()"
          (valueChange)="setSegmentsFilter($event)"
          class="ml-3 max-w-xl min-w-0"
          [(searchQuery)]="searchQuery"
        >
          <ISelectTrigger>
            <ISelectValue [placeholder]="t('keyword-tracker-page.keyword_segment')">
              <div class="truncate" *iSelectValue="let value">
                {{ t("common.selected", { count: value.length }) }}
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (segment of filteredKeywordSegment(); track segment.segmentId) {
              <ISelectOption [value]="segment">
                {{ segment.name }}
              </ISelectOption>
            }
          </ISelectContent>
        </IMultiSelectMenu>
      </div>

      <div class="flex items-center gap-2">
        @if (selectedRows().length > 0) {
          <button iButton variant="destructive" [disabled]="isReadOnly()" (click)="deleteSelected()">
            <IIcon name="trash" />
            {{ t("common.delete_x", { count: selectedRows().length }) }}
          </button>
        }
        <button iButton [disabled]="isReadOnly()" (click)="addNewKeyword()">
          <IIcon name="plus" />
          {{ t("add-keyword-tracking-modal.track_new_keyword_title") }}
        </button>
        <app-export-button (export)="exportAsCsv()" tooltipValue="{{ t('common.export_as_csv') }}"></app-export-button>
      </div>
    </div>

    <div class="grid-wrapper ag-theme-quartz mt-3 flex-1">
      <ag-grid-angular
        style="width: 100%"
        class="h-full"
        [rowData]="gridData()"
        [gridOptions]="gridOptions"
      ></ag-grid-angular>
    </div>
  } @else {
    <div class="flex h-full w-full items-center justify-center">
      <IEmptyState
        [title]="t('keyword-tracker-page.no_search_tracked')"
        [description]="t('keyword-tracker-page.no_search_tracked_description')"
        [ctaLabel]="t('keyword-tracker-page.add_first_search_term')"
        ctaIcon="add"
        [ctaDisabled]="isReadOnly()"
        (ctaClick)="addNewKeyword()"
      />
    </div>
  }
</div>
